'use strict';
import ready from "./ready";
import promiseIdle from "./promise-idle";
import {delegate} from "./events";

ready().then(promiseIdle()).then(function () {
    const selector = 'a[data-o][role="link"]';
    document.addEventListener('mouseover', function handler() {
        document.querySelectorAll(selector).forEach(restore);
        document.removeEventListener('mouseover', handler);
    });
    document.addEventListener('focusin', function handler() {
        document.querySelectorAll(selector).forEach(restore);
        document.removeEventListener('focusin', handler);
    });
    document.addEventListener('click', delegate(selector, function (e) {
        restore(e.target);
    }));

    function restore(link) {
        link.setAttribute('href', atob(link.getAttribute('data-o')));
        link.removeAttribute('data-o');
        link.removeAttribute('tabindex');
        link.removeAttribute('role');
    }
});
